import { atom } from 'nanostores';

export interface MigrationState {
  needsMigration: boolean;
  migrationFailed: boolean;
  migrationError?: string;
}

export const needsMigrationStore = atom<MigrationState>({
  needsMigration: false,
  migrationFailed: false,
  migrationError: undefined,
});
